export const BreadCrumbCss = {
  main: {
    background: "#1E272D",
    color: "#fff",
    padding: "27px 0 26px 0",
    position: "relative" as const,
    minHeight: '78px',
    display: 'inline-block',
    width: '100%',
    marginTop: '75px'
  },
  contentContainer: {
    display: "flex",
    justifyContent: "center",
    webkitBoxAlign: "center",
    alignItems: "center",
    margin: 0
  },
  listItem: {
    color: "#ddd",
    marginRight: "20px",
    fontSize: "20px",
    fontWeight: "bold",
    letterSpacing: "0.3px",
    display: "inline-block",
    lineHeight: 1,
    position: "relative" as const
  },
  mainHeading: {
    color: "#ffffff",
    lineHeight: "25px",
    margin: 0,
    fontSize: "25px",
    fontWeight: 600
  }
};
